import consumer from './consumer';
import { log } from '../utils/logger';

consumer.subscriptions.create('FlashMessageChannel', {
  connected() {
    log('connected to FlashMessageChannel');
  },

  disconnected() {
    log('disconnected from FlashMessageChannel');
  },

  received(data) {
    log('message received from FlashMessageChannel', data);

    let body = document.querySelector(`.${data.page}`);
    if (body) {
      let flash = document.createElement('div');
      flash.classList.add('flash', `flash_${data.type}`);
      flash.innerHTML = data.message;
      body.insertBefore(flash, body.firstChild);
    }
  },
});
